module.exports = __webpack_public_path__ + "img/undraw_personal_information_962o.1d5668ea.svg";